angular.module('dpw.components')
    .directive('dpwSticker', [function () {
        return {
            restrict: 'EA',
            scope: {},
            transclude: true,
            templateUrl: 'dpw-sticker.html',
            link: function (scope, element, attrs) {
                var classes = [];
                attrs.dsStyle && classes.push('dpw-sticker-' + attrs.dsStyle);
                attrs.dsClass && (classes = classes.concat(attrs.dsClass.split(' ')));
                scope.classes = classes;
            }
        };
    }]);